export default {
    en: {
        settings: 'Settings',
        general: 'General',
        timeline: 'Timeline',
        appearance: 'Appearance',
        security: 'Security',
        waitlist: 'Waitlist',
        content: 'Back',
        displaySensitiveByDefault: 'Display sensitive content by default'
    },
    hu: {
        beállítások: 'Beállítások',
        general: 'Általános',
        timeline: 'Idővonal',
        appearance: 'Megjelenés',
        security: 'Biztonság',
        waitlist: 'Várólista',
        content: 'Vissza',
        displaySensitiveByDefault: 'Érzékeny tartalom alapértelmezett megjelenítése'
    }
}